import {BaseOptions} from '../../../../dialog/options/base.options';

export class AddOrUpdateSpacesOptions extends BaseOptions {
  space?: any;

  onInsertOrUpdateFinished() {
  }
}
